// extracted by mini-css-extract-plugin
export var active = "index-module--active--8doI7";
export var descriptionWrapper = "index-module--descriptionWrapper--DT4Zf";
export var imageWrapper = "index-module--imageWrapper--RjxfE";
export var listItemRoot = "index-module--listItemRoot--Buz-w";
export var listWrapper = "index-module--listWrapper--ZHXC-";